import classes from "./Footer.module.css";
import appleMini from "./../../assets/images/apple_mini.png";
import androidMini from "./../../assets/images/android_mini.jpg";
import information from "./../../assets/images/information_project.png";
import {
  androidAppLink,
  informationLink,
  informationLinkEN,
  iosAppLink,
} from "../../../SMARTCITY/hardCodeData/DATA";
import { useContext } from "react";
import LanguageContext from "../../hooks/language-context";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const languageCtx = useContext(LanguageContext);
  const { t } = useTranslation();
  return (
    <footer
      style={{
        position: "absolute",
        bottom: "0",
        left: "0",
        width: "100%",
        zIndex: "5",
      }}
    >
      <div
        style={{
          height: "30px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "0 20px",
          backgroundColor: "white",
          zIndex: "5",
        }}
      >
        <p>
          &copy;{new Date().getFullYear()} {t("municipality")}
        </p>
        <div>
          <button
            onClick={() =>
              window.open(
                languageCtx.languageCode === "en"
                  ? informationLinkEN
                  : informationLink,
              )
            }
          >
            <img
              style={{ width: "22px", cursor: "pointer", marginTop: "4px" }}
              src={information}
              alt="Project information"
            />
          </button>
          {/* <img
          src={appleMini}
          alt={"apple-application"}
          onClick={() => window.open(iosAppLink)}
        />
        <img
          src={androidMini}
          alt={"android-application"}
          onClick={() => window.open(androidAppLink)}
        /> */}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
